import React from "react";
import { PropTypes } from "prop-types";
import { mergeOrOverrideCss } from "mrb/common/utils";
import { nakiRadioUserAccessType } from "common/constants";

function NakiRadioPremiumBadgeTemplate({ classNameOverride, iconSize, userAccessType }) {
    const className = mergeOrOverrideCss(
        userAccessType === nakiRadioUserAccessType.premium
            ? "u-icon u-icon--plan u-icon--plan--premium-naki-logo"
            : "u-icon u-icon--plan u-icon--plan--premium",
        classNameOverride,
        iconSize ? `u-icon--plan--${iconSize}` : "u-icon--plan--base"
    );
    return <i className={className} />;
}

NakiRadioPremiumBadgeTemplate.propTypes = {
    classNameExtend: PropTypes.string,
    classNameOverride: PropTypes.string,
    userAccessType: PropTypes.string,
};

export default NakiRadioPremiumBadgeTemplate;
